const O={PRE_LOGIN:1272,POST_LOGIN:1200};export{O as WIDTH_SIZES};
//# sourceMappingURL=constants.js.map
